import { render, staticRenderFns } from "./LogoutConfirmationModal.vue?vue&type=template&id=6cf24324&scoped=true&"
import script from "./LogoutConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./LogoutConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./LogoutConfirmationModal.vue?vue&type=style&index=0&id=6cf24324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf24324",
  null
  
)

export default component.exports